import { Stack } from "expo-router";
import { ensureStackAnchorListeners } from "@utils/navigation/ensureStackAnchor";
import { ComponentProps } from "react";

type StackScreenOptions = NonNullable<
  ComponentProps<typeof Stack.Screen>["options"]
>;

export const unstable_settings = {
  initialRouteName: "index",
};

const defaultScreenOptions = (
  options?: StackScreenOptions,
): StackScreenOptions => {
  return {
    ...options,
    animation: "default",
    headerShown: false,
  };
};

export default function LibraryStack() {
  return (
    <Stack
      screenOptions={{
        ...defaultScreenOptions(),
        contentStyle: { backgroundColor: "transparent" },
        animation: "none",
      }}
      screenListeners={ensureStackAnchorListeners("index")}
    >
      <Stack.Screen name="index" />
      <Stack.Screen
        name="[collectionType]/[collectionId]/index"
        options={defaultScreenOptions()}
        getId={({ params }) =>
          `${params?.collectionType}/${params?.collectionId}`
        }
      />
      <Stack.Screen name="artist/[artistId]" options={defaultScreenOptions()} />
    </Stack>
  );
}
